// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-tag-red[data-v-b2618a46] {\n  background: #fce8e5 !important;\n}\n.bg-tag-green[data-v-b2618a46] {\n  background: #effcf7 !important;\n}", ""]);
// Exports
module.exports = exports;
